// English translations
const en = {
  // Header translations
  transaction: 'Transaction',
  prop: 'Prop',
  explore: 'Explore',
  profit: 'Profit',
  assets: 'Assets',
  credit: 'Credit',
  balance: 'Balance',
  freeMargin: 'Free Margin',
  margin: 'Margin',
  marginLevel: 'Margin Level',
  openRealAccount: 'Open Real Account',
  
  // Market Watch
  marketWatch: 'Market Watch',
  favorites: 'Favorites',
  mostActive: 'Most Active',
  all: 'All',
  searchSymbols: 'Search symbols...',
  
  // Trading Actions
  buy: 'BUY',
  sell: 'SELL',
  close: 'Close',
  
  // Trading Modal
  market: 'Market',
  pending: 'Pending',
  lot: 'Lot',
  price: 'Price',
  optional: 'Optional',
  marketOrder: 'Market Order',
  pendingOrder: 'Pending Order',
  executionPrice: 'Execution Price',
  cancel: 'Cancel',
  
  // Positions Panel
  open: 'Open',
  openPositions: 'Open Positions',
  pending: 'Pending',
  pendingOrders: 'Pending Orders',
  closed: 'Closed',
  closedPositions: 'Closed Positions',
  finance: 'Finance',
  noOpenPositions: 'You have no open positions. Start trading to see your open positions here.',
  noPendingOrders: 'No pending orders found.',
  noClosedPositions: 'No closed positions found.',
  noFinancialHistory: 'No financial history found.',
  
  // Common terms
  symbol: 'Symbol',
  type: 'Type',
  pnl: 'P/L',
  swap: 'Swap',
  commission: 'Commission',
  spread: 'Spread',
  time: 'Time',
  
  // Account info
  equity: 'Equity',
  usedMargin: 'Used Margin',
  accountBalance: 'Account Balance',
  
  // Connection status
  connected: 'Connected',
  connecting: 'Connecting...',
  disconnected: 'Disconnected',
  
  // Mobile-specific translations
  accountSummary: 'Account Summary',
  selectField: 'Select Field',
  
  // Modal-specific translations
  buyOrder: 'Buy Order',
  sellOrder: 'Sell Order',
  
  // Navigation translations
  symbols: 'Symbols',
  chart: 'Chart',
  positions: 'Positions',
  
  // Account management
  account: 'Account',
  notifications: 'Notifications',
  markAllRead: 'Mark All Read',
  noNotifications: 'No notifications',
  
  // Market Watch Settings Modal
  marketWatchSettings: 'Market Watch Settings',
  general: 'General',
  display: 'Display',
  generalSettings: 'General Settings',
  displaySettings: 'Display Settings',
  autoRefresh: 'Auto Refresh',
  autoRefreshDesc: 'Automatically refresh prices',
  soundAlerts: 'Sound Alerts',
  soundAlertsDesc: 'Sound alerts for price changes',
  updateInterval: 'Update Interval',
  second: 'second',
  seconds: 'seconds',
  showSpread: 'Show Spread',
  showSpreadDesc: 'Show bid-ask spread',
  showVolume: 'Show Volume',
  showVolumeDesc: 'Show trading volume',
  decimalPlaces: 'Decimal Places',
  colorTheme: 'Color Theme',
  default: 'Default',
  greenRed: 'Green-Red',
  blueOrange: 'Blue-Orange',
  save: 'Save',

  // Technical Indicators
  indicators: 'Indicators',
  technicalIndicators: 'Technical Indicators',
  sma20: 'SMA 20',
  sma50: 'SMA 50',
  ema12: 'EMA 12',
  ema26: 'EMA 26',
  rsi14: 'RSI 14',
  bollingerBands: 'Bollinger Bands',
  movingAverage: 'Moving Average',
  exponentialMovingAverage: 'Exponential Moving Average',
  relativeStrengthIndex: 'Relative Strength Index',
  macd: 'MACD',
  stochastic: 'Stochastic',
  atr: 'ATR',
  
  // Chart loading states
  loadingChart: 'Loading Chart...',
  initializing: 'Initializing',
  chartReady: 'Chart Ready',

  // Account creation
  createAccount: 'Create Account',
  newAccount: 'Create New Account',
  accountType: 'Account Type',
  selectAccountType: 'Select account type',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  enterPassword: 'Enter account password',
  reenterPassword: 'Re-enter password',
  liveAccount: 'Live Account',
  demoAccount: 'Demo Account',
  practiceAccount: 'Practice Account',
  islamicAccount: 'Islamic Account',
  passwordMismatch: 'Passwords do not match!',

  // Performance table
  performance: 'Performance',
  performanceMetrics: 'Performance Metrics',
  totalTrades: 'Total Trades',
  winningTrades: 'Winning Trades',
  losingTrades: 'Losing Trades',
  winRate: 'Win Rate',
  totalProfit: 'Total Profit',
  totalLoss: 'Total Loss',
  netProfit: 'Net Profit',
  averageWin: 'Average Win',
  averageLoss: 'Average Loss',
  profitFactor: 'Profit Factor',
  maxDrawdown: 'Max Drawdown',
  consecutiveWins: 'Consecutive Wins',
  consecutiveLosses: 'Consecutive Losses',
  totalVolume: 'Total Volume',
  tradingHistory: 'Trading History',
  loading: 'Loading...',
  noTradeHistory: 'No trade history found',

  // Positions table specific translations
  id: 'ID',
  amount: 'Amount',
  openTime: 'Open Time',
  openPrice: 'Open Price',
  closePrice: 'Close Price',
  stopLoss: 'Stop Loss',
  takeProfit: 'Take Profit',
  actions: 'Actions',
  edit: 'Edit',
  searchSymbol: 'Search symbol...',
  loadingPositions: 'Loading positions...',
  trading: 'Trading',
  orders: 'Orders',
  history: 'History',
  openPositionsAndPending: 'Open Positions & Pending',
  previous: 'Previous',
  next: 'Next',
  page: 'Page',
  of: 'of',
  noData: 'No data found',
  items: 'items',
  itemsPerPage: 'Items per page',
  
  // Orders specific translations
  orderType: 'Order Type',
  orderPrice: 'Order Price',
  currentPrice: 'Current Price',
  placed: 'Placed',
  expires: 'Expires',
  gtc: 'Good Till Cancel',
  noOrdersAvailable: 'No pending orders available',
  
  // Chart specific translations
  trendLine: 'Trend Line',
  dynamicTrend: 'Dynamic Trend',
  
  // Loading states
  loadingSymbols: 'Loading symbols...',
  noSymbolsFound: 'No symbols found',
  
  // Register/Login translations
  'Personal Information': 'Personal Information',
  'Account Preferences': 'Account Preferences',
  'Verification': 'Verification',
  'Create Your Zonex Account': 'Create Your Zonex Account',
  'Join the professional trading platform': 'Join the professional trading platform',
  'First name is required': 'First name is required',
  'Last name is required': 'Last name is required',
  'Email is required': 'Email is required',
  'Please enter a valid email address': 'Please enter a valid email address',
  'Phone number is required': 'Phone number is required',
  'Password is required': 'Password is required',
  'Password must be at least 8 characters': 'Password must be at least 8 characters',
  'Passwords do not match': 'Passwords do not match',
  'Please select your trading experience level': 'Please select your trading experience level',
  'You must agree to the Terms of Service': 'You must agree to the Terms of Service',
  'You must agree to the Privacy Policy': 'You must agree to the Privacy Policy',
  'ID document is required': 'ID document is required',
  'Proof of address is required': 'Proof of address is required',
  'Registration failed': 'Registration failed',
  'Registration successful! Please check your email to verify your account.': 'Registration successful! Please check your email to verify your account.',
  'Please check your email and click the verification link.': 'Please check your email and click the verification link.',
  'Previous': 'Previous',
  'Next': 'Next',
  'Creating Account...': 'Creating Account...',
  'Create Account': 'Create Account',
  'Already have an account?': 'Already have an account?',
  'Sign in here': 'Sign in here',
  'Registration failed. Please try again.': 'Registration failed. Please try again.',
  
  // 404 Page
  pageNotFound: 'Page Not Found',
  pageNotFoundMessage: "The page you're looking for doesn't exist. Let's get you back!",
  goBack: 'Go Back',
  backToHome: 'Back to Home',
  
  // Toast messages
  orderPlaced: 'Order Placed',
  orderFailed: 'Order failed. Please try again.',
  orderSuccess: 'Order placed successfully',
  positionClosed: 'Position closed',
  positionCloseFailed: 'Failed to close position',
  orderCancelled: 'Order cancelled',
  orderCancelFailed: 'Failed to cancel order',
  positionUpdated: 'Position updated',
  positionUpdateFailed: 'Failed to update position',
  positionsClosed: 'positions closed',
  ordersCancelled: 'orders cancelled',
  bulkCloseFailed: 'Bulk close failed',
  bulkCancelFailed: 'Bulk cancel failed',
  noPositionsSelected: 'No positions selected',
  noOrdersSelected: 'No orders selected',
  
  // Edit position
  editPosition: 'Edit Position',
  selected: 'selected',
  closeSelected: 'Close Selected',
  clearSelection: 'Clear Selection',
  
  // Partial close
  partialClose: 'Partial Close',
  volumeToClose: 'Volume to Close',
  closePercentage: 'Close Percentage',
  remaining: 'Remaining',
  closing: 'Closing',
  estimatedProfit: 'Estimated Profit',
  invalidVolume: 'Invalid volume',
  volumeTooHigh: 'Volume cannot exceed total amount',
  partialCloseFailed: 'Partial close failed',
  closePosition: 'Close Position',
  partial: 'Partial',
  opened: 'Opened',
  closed: 'Closed',
  closeTime: 'Close Time',
  
  // Finance tab
  financeSection: 'Finance Section',
  financeSectionDesc: 'Financial transactions and account activities will be displayed here',
  description: 'Description',
  reference: 'Reference',
  status: 'Status',
  completed: 'Completed',
  failed: 'Failed',
  date: 'Date',
  noTransactions: 'No transactions found',
  
  // Symbol Categories
  fx: 'FX',
  crypto: 'Crypto',
  popular: 'Popular',
  stocks: 'Stocks',
  commodities: 'Commodities',
  indices: 'Indices',
  price: 'Price',
  
  // Chart Types
  lineChart: 'Line Chart',
  barChart: 'Bar Chart',
  candlestickChart: 'Candlestick Chart',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  resetZoom: 'Reset Zoom',
  
  // Order Messages
  positionOpened: 'Position Opened',
  orderPending: 'Pending Order Created',
  
  // Indicators
  indicators: 'Indicators',
  technicalIndicators: 'Technical Indicators',
  indicatorsSelected: 'indicators selected',
  period: 'Period',
  stdDev: 'Standard Deviation',
  apply: 'Apply',
  enableIndicator: 'Enable Indicator',
  enabled: 'Enabled',
  disabled: 'Disabled',
  parameters: 'Parameters',
  color: 'Color',
  selectIndicator: 'Select an indicator',
  clear: 'Clear',
  add: 'Add',
  quickTrade: 'Quick Trade',
  quickTradeActive: 'Quick Trade Active',
  quickTradeInactive: 'Quick Trade Inactive',
  
  // Header Mobile
  language: 'Language',
  appearance: 'Appearance',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',
  markAllRead: 'Mark all as read',
  noNotifications: 'No notifications',
  inbox: 'Inbox',
  noMessages: 'No messages',
  noMessagesDescription: 'You have no messages at the moment. Some notifications may take time to appear. Please check again later.',
  support: 'Support',
  announcement: 'Announcement',
  noSupportMessages: 'No support messages',
  noSupportMessagesDesc: 'No support requests yet.',
  noAnnouncements: 'No announcements',
  noAnnouncementsDesc: 'No announcements yet.',
  noFinanceMessages: 'No finance notifications',
  noFinanceMessagesDesc: 'No financial transaction notifications yet.',
  justNow: 'Just now',
  new: 'New',
  completed: 'Completed',
  equity: 'Equity',
  leverage: 'Leverage',
  settings: 'Settings',
  createNewTradingAccount: 'Create New Trading Account',
  minPasswordLength: 'Minimum 8 characters required',
  realAccount: 'Real Account',
  tradeWithRealMoney: 'Trade with real money',
  practiceWithVirtualMoney: 'Practice with virtual money',
  accountFeatures: 'Account Features',
  standardAccount: 'Standard Account',
  standardFeatures: 'Standard features',
  swapFree: 'Swap free',
  premiumSupport: 'Premium support',
  zeroCommission: 'Zero commission',
  vipAccount: 'VIP Account',
  noCommissionAccount: 'No Commission Account',
  selectLeverage: 'Select Leverage',
  leverageWarning: 'High leverage involves high risk',
  minimumDeposit: 'Minimum Deposit',
  maximumLeverage: 'Maximum Leverage',
  free: 'Free',
  pleaseSelectAccountType: 'Please select account type',
  pleaseSelectAccountFeatures: 'Please select account features',
  accountCreatedSuccessfully: 'account created successfully'
};

export default en;